import { authHeaders, baseUrl, handleResponse } from './apiUtils';

async function getTypes() {
  return handleResponse(await fetch(`${baseUrl}billing-discounts/types`, { headers: authHeaders() }));
}
async function getGrants(clientId, cursor) {
  let query = '';
  if (clientId) query = `?clientId=${encodeURIComponent(clientId)}`;
  else if (cursor) query = `?cursor=${encodeURIComponent(cursor)}`;
  return handleResponse(await fetch(`${baseUrl}billing-discounts/grants${query}`, { headers: authHeaders() }));
}
async function command(kind, input) {
  return handleResponse(await fetch(`${baseUrl}billing-discounts/${kind}`, {
    method: 'POST', headers: authHeaders({ 'content-type': 'application/json' }), body: JSON.stringify(input),
  }));
}
export default { getTypes, getGrants, saveType: input => command('types', input), saveGrant: input => command('grants', input) };
